module.exports = __webpack_public_path__ + "static/media/buy-and-sell-with-li@3x.3770270a.png";